export const tabIndexes = {
  options: 1000,
};
